var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportantIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6753 5H1.04578C0.625575 5 0.392786 5.48689 0.656624 5.81394L5.3938 11.6861C5.54159 11.8693 5.54159 12.1307 5.3938 12.3139L0.656625 18.1861C0.392787 18.5131 0.625575 19 1.04578 19H17.6753C17.8868 18.9999 18.0955 18.9526 18.2861 18.8618C18.4767 18.7709 18.6443 18.6387 18.7765 18.475L23.7467 12.3139C23.8945 12.1307 23.8945 11.8693 23.7467 11.6861L18.7765 5.525C18.6443 5.36129 18.4767 5.22912 18.2861 5.13825C18.0955 5.04738 17.8868 5.00013 17.6753 5Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIconColor);
export default __webpack_public_path__ + "static/media/important_icon_color.20f0784d9804272e61c438583cb87887.svg";
export { ForwardRef as ReactComponent };